import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { Share2 } from "lucide-react";
import { publicApi } from "@/lib/api";
import { shareUrl } from "@/components/site/ShareButton";

const NUDGE_AFTER_SEC = 8;
const releaseIdOf = (track) => (track?.releaseId || String(track?.id || "").split(":")[0] || "");

export const useShareNudge = (track, isPlaying, current) => {
  const shown = useRef(new Set());
  useEffect(() => {
    const rid = releaseIdOf(track);
    if (!rid || !isPlaying || current < NUDGE_AFTER_SEC || shown.current.has(rid)) return;
    if (sessionStorage.getItem(`hns_nudged_${rid}`)) { shown.current.add(rid); return; }
    shown.current.add(rid);
    sessionStorage.setItem(`hns_nudged_${rid}`, "1");
    const url = shareUrl("album", rid);
    const share = async () => {
      publicApi.post("/public/share", { kind: "album", id: rid }).catch(() => {});
      if (navigator.share) {
        try { await navigator.share({ title: `${track.title} — ${track.artist}`, text: "Listen to this", url }); return; } catch (e) { if (e?.name === "AbortError") return; }
      }
      try { await navigator.clipboard.writeText(url); toast.success("Link copied — send it to someone who needs this song"); }
      catch { window.prompt("Copy this link", url); }
    };
    toast(`Feeling ${track.title}?`, {
      id: `nudge-${rid}`,
      description: "Share it with someone who needs to hear it.",
      duration: 9000,
      icon: <Share2 size={14} color="var(--gold)" />,
      action: { label: "Share", onClick: share },
      // eslint-disable-next-line react/no-unknown-property
      className: "hns-nudge",
    });
  }, [track, isPlaying, current]);
};
